import { ReportGroup } from "../models/reports.groups";
import BaseService from "./_base.service";

import API from "../api";


const endpoint = "container/conference";

export const ContainerConferenceService = {
  ...BaseService<ReportGroup>({ endpoint }),

  async getCrossDock(options?: any): Promise<any> {
    return await API.get(`${endpoint}/crossdock`, {
      params: options,
    });
  },
};
